import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { A } from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { radiuses } from '../../../../constants'

const SearchRadius = ({ className, selectedItemPositionHandler, searchRadius }) =>
  <div className={ className }>
    <CustomText data-at-search-radius-title>Change Search Radius</CustomText>
    <LinksWrapper aria-label="Change Search Radius">
      {
        radiuses.map((radius, index) =>
          <ListElement key={ index }>
            <CustomLink
              bolder
              key={ radius }
              data-at-search-radius-button
              selected={ searchRadius === radius }
              prevent
              handler={ () => { selectedItemPositionHandler(radius) } }>
              {radius} mi
            </CustomLink>
          </ListElement>)
      }
    </LinksWrapper>
  </div>

export default SearchRadius

SearchRadius.propTypes = {
  className: PropTypes.string,
  searchRadius: PropTypes.number,
  selectedItemPositionHandler: PropTypes.func
}

const CustomText = styled.div`
  ${Media.desktop`
    display: inline-block;
  `}
  ${Mixin.responsive('font-size', '14px', '12px')}
`

const LinksWrapper = styled.ul`
  padding: 0;
  ${Media.desktop`
    display: inline-block;
  `}
  ${Mixin.responsive('margin', '0 0 0 20px', '10px 0 0 0')};
`

const ListElement = styled.li`
  display: inline-block;

  & + &::before {
    margin: 0 5px;
    content: "|";
    color: ${Theme.colors.light_grey};
  }
`

const CustomLink = styled(A)`
  font-size: 12px;
  ${props => props.selected && css`
    text-decoration: underline;
  `
}
`
